
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  description?: string;
  trend?: number;
  trendIcon?: React.ReactNode;
}

const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  icon, 
  description,
  trend,
  trendIcon
}) => {
  return (
    <Card className="overflow-hidden transition-all duration-200 hover:shadow-md border-t-4 border-t-primary-blue transform hover:-translate-y-1 group">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 bg-gradient-to-r from-blue-50 to-transparent">
        <CardTitle className="text-sm font-medium text-primary-blue group-hover:text-blue-700 transition-colors">{title}</CardTitle>
        <div className="h-10 w-10 rounded-full bg-primary-blue/10 p-2 text-primary-blue flex items-center justify-center group-hover:bg-primary-blue/20 transition-colors">
          {icon}
        </div>
      </CardHeader>
      <CardContent className="pt-4">
        <div className="text-2xl font-bold font-display">{value}</div>
        
        <div className="flex items-center justify-between mt-1">
          {description && (
            <p className="text-xs text-muted-foreground">{description}</p>
          )}
          
          {trend !== undefined && trendIcon && (
            <div className="flex items-center text-xs font-medium">
              {trendIcon}
              <span className={trend >= 0 ? "text-green-600" : "text-red-600"}>
                {trend > 0 ? '+' : ''}{trend.toFixed(1)}%
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
